import { ServiceCode } from '../../common/enums/serviceCode';
import { SomnologyOrganizationType } from '../../common/enums/somnologyOrganizationType';

const servicesWithAutoSave = [
    ServiceCode.OSASVC,
    ServiceCode.GGZCf2f,
    ServiceCode.GGZCg,
    ServiceCode.GGZCmdo,
    ServiceCode.GGZCt,
    ServiceCode.GGZCtriage,
    ServiceCode.GGZv,
    ServiceCode.TOO,
    ServiceCode.TFO,
    ServiceCode.TCOH,
    ServiceCode.TCCh,
    ServiceCode.TCOR,
    ServiceCode.TCCr,
    ServiceCode.OrthO,
    ServiceCode.OrthOFol,
];

function checkOsasC2AutoSave(serviceCode: ServiceCode, customControlData: any, customControlVersion?: number) {
    return (
        serviceCode === ServiceCode.OSASC2 &&
        customControlVersion === 2 &&
        customControlData?.somnologyOrganizationType === SomnologyOrganizationType.ksyosMedicalCenter
    );
}

export function isAutoSaveActiveByService(
    serviceCode: ServiceCode,
    disableFormAutosave: boolean,
    customControlVersion?: number,
    customControlData?: any
) {
    if (disableFormAutosave) {
        return false;
    }

    return (
        servicesWithAutoSave.includes(serviceCode) ||
        checkOsasC2AutoSave(serviceCode, customControlData, customControlVersion)
    );
}
